import { render, staticRenderFns } from "./Microsoft.vue?vue&type=template&id=543aecdc&scoped=true&"
import script from "./Microsoft.vue?vue&type=script&lang=js&"
export * from "./Microsoft.vue?vue&type=script&lang=js&"
import style0 from "./Microsoft.vue?vue&type=style&index=0&id=543aecdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543aecdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543aecdc')) {
      api.createRecord('543aecdc', component.options)
    } else {
      api.reload('543aecdc', component.options)
    }
    module.hot.accept("./Microsoft.vue?vue&type=template&id=543aecdc&scoped=true&", function () {
      api.rerender('543aecdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/emailChannels/Microsoft.vue"
export default component.exports